// react
import { useContext } from 'react';

// types
import { Account } from '../../../../../@types';

// context
import { ContextAccountsDesignated, ContextProject } from '../../Project.context';

// mui
import { Container, Grid } from '@mui/material';

// tables
import { TableAccounts } from '../../../../tables/cards/TableAccounts/TableAccounts';

export const Designated = () => {
	// context
	const {
		accountsDesignated,
		isLoadingAccountsDesignated,
		paginationAccountsDesignated,
		refetchAccountsDesignated,
	} = useContext(ContextAccountsDesignated);
	const { isLoadingProject } = useContext(ContextProject);

	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<Container maxWidth={false}>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<TableAccounts
								accounts={accountsDesignated as Account[]}
								isLoading={isLoadingAccountsDesignated || isLoadingProject}
								pagination={paginationAccountsDesignated}
								refetchAccounts={refetchAccountsDesignated}
								type="DESIGNATED"
							/>
						</Grid>
					</Grid>
				</Container>
			</Grid>
		</Grid>
	);
};
